import React from 'react'
import { AccordionItem } from './AccordionItem'
import { useQuery } from 'react-query'
import { get } from 'src/apis/apiService'
import Axios from 'axios'
import config from 'src/config'

export type Programme = {
  id: number
  title: string
  time: string
  bio: string
  image: string
}

export default function ProgrammeAccordion() {
  const { data } = useQuery<Programme[]>(
    'programme',
    async () => {
      try {
        const response = await Axios.get(`${config.apiUrl}/api/speakers`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
          },
        })
        return response.data.data
      } catch (error) {
        console.error('Error fetching programmes:', error)
        return []
      }
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  )

  const programmes = data || []
  return (
    <div className="d-flex flex-column gap-3" style={{ gap: '16px' }}>
      {!programmes ? <>No speakers found</> : programmes.map((programme) => <AccordionItem key={programme.id} data={programme} />)}
    </div>
  )
}
